<template>
    <div class="container testimonial_list">
        <CommonBreadcrumb class="bread_block" /> 
        
        <TestimonialsShareMoment />

       
        <div class="row" v-if="list">
            <TestimonialsTestimonialPreview v-for="item in list" :key="item.id" :item="item" />
        </div>

        <div class="loader" v-if="pending">
            <img width="200" loading="lazy" height="200" alt="loader" src="~/assets/assets/loader.svg" />
        </div>


        <div class="show_more_block mt-4" v-if="isShowMore">
            <div class="show_more_btn" @click="loadNextPage">Show More</div>
        </div>
    </div>
</template>

<script setup>
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
    const list = ref([])
    const isShowMore = ref(null)
    const urlParams = ref({
        page: 1,
    })

    const { data, pending, refresh, error } = await useFetch(useCountryPath('/testimonials'), {
        query: urlParams,
        watch: [urlParams],
        transform: (res) =>{
            if(res.data.data.length > 0){
                res.data.data.filter((item) => list.value.push(item))
                isShowMore.value = res.data.next_page_url
            }
        }
    }) 

    const loadNextPage = () => {
        urlParams.value.page++
    }
    


    // const page = ref(1);
    // const productsFetched: any = ref([]);

    // const { data: products  }: any = await useFetch('url', {
    // params: { page },
    // watch: [page],
    // transform: (res: any) => {
    //     productsFetched.value = [...productsFetched.value, ...res.newProducts];
    //     return productsFetched.value;
    // },
    // });

    // const loadMore = () => {
    // page.value =++;
    // }
</script>

<style scoped>
.show_more_block {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.show_more_btn {
    display: inline-block;
    font-size: 14px;
    padding: 12px 18px;
    color: #000;
    border: 1px solid #000;
    border-radius: 4px;
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
    min-width: 200px;
}
.loader{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>